<template>
  <v-dialog max-width="500px" v-model="dialog" @keydown.enter.prevent="onenter">
    <v-card>
      <v-card-title>
        <span class="headline">Swamp ({{ this.rules.name }})</span>
        <v-spacer/>
        <r-authorize
            :master="masterAccess"
            :locked.sync="model.locked"
            :enabled.sync="model.enabled"
        />
      </v-card-title>
      <v-card-text>
        <v-col cols="4" sm="2" md="2">
          <v-btn @click="showPreview()" class="mr-2" small>View JSON</v-btn>
        </v-col>
        <v-row dense>
          <v-col cols="12" md="2" sm="2">
            <v-text-field label="ID:" v-model.number="model.id" hide-details/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field label="Width:" v-model.number="model.width" hide-details/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field label="Height:" v-model.number="model.height" hide-details/>
          </v-col>
          <v-col cols="12" md="2" sm="2">
            <v-text-field label="Path Length:" v-model.number="model.pathLength" hide-details/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="6" sm="6">
            <r-item-dropdown label="Hero Item:" :model.sync="model.heroItem"/>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <r-tile label="Finish Hero Teleport Tile" :model.sync="model.heroTeleportTile" hide-details/>
          </v-col>
          <v-col cols="12"/>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="6" sm="6">
            <r-item-dropdown label="Path Item:" :model.sync="model.pathItem"/>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <r-item-dropdown label="Block Item:" :model.sync="model.blockItem"/>
          </v-col>
          <v-col cols="12"/>
        </v-row>
        <v-row dense>
            <v-col cols="12" md="6" sm="6">
                <r-tile label="Bottom Left Tile" :model.sync="model.bottomLeftTile" hide-details/>
            </v-col>
            <v-col cols="12" md="6" sm="6">
                <r-tile label="Top Right Tile" :model.sync="model.topRightTile" hide-details/>
            </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text v-if="!lockedAssess || masterAccess">
          Save
        </v-btn>
      </v-card-actions>
      <r-preview-dialog ref="preview-dialog"></r-preview-dialog>
    </v-card>
  </v-dialog>
</template>

<script>
import {ViewRules} from "@/common/ViewRules";
import { Swamp } from "@/modules/redactor/models/world-biomes/swamp/Swamp";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

import RAuthorize from "@/modules/redactor/views/common/r-authorize";
import RItemDropdown from "@/modules/redactor/views/item/r-item-dropdown";
import RTile from "@/modules/redactor/views/utils/r-tile.vue";
import RPreviewDialog from "@/modules/redactor/views/preview/r-preview-dialog.vue";
import {MapAddonGroupModel} from "@/modules/redactor/models/map-addon/core/MapAddonGroupModel";

export default {
  name: "r-swamp-dialog",
  components: {RPreviewDialog, RTile, RItemDropdown, RAuthorize},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new Swamp(),
    rules: ViewRules.READONLY,
  }),
  computed: {
    lockedAssess() {
      return this.model.locked;
    },
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new Swamp();

      if (ViewRules.COPY.equal(this.rules)) {
        this.model.locked = false;
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },
    onenter() {
      if (!this.lockedAssess || this.masterAccess) {
        this.save();
      } else {
        this.cancel();
      }
    },
    showPreview() {
      this.$refs['preview-dialog'].show(this.rules, this.model, Swamp)
        .then((result) => {
          Object.assign(this.model, result);
        })
        .catch((e) => {
          this.$alert("Failed to parse config!" + e.message);
        });
    }
  }
}
</script>